import { deleteTodo, loadTodos, postTodo, putTodo } from './services/todos';

const todos = document.getElementById('todos');
const todoTemplate = document.getElementById('todo');
const form = document.getElementById('todo-form');
const counter = document.querySelector('[role="counter"]');
const clearCompleted = document.querySelector('[role="clearCompleted"]');
const filterAll = document.querySelector('[role="filterAll"]');
const filterActive = document.querySelector('[role="filterActive"]');
const filterCompleted = document.querySelector('[role="filterCompleted"]');
const tokenForm = document.querySelector('[role="tokenForm"]');
const app = document.querySelector('[role="app"]');

let token = null;
const setToken = (input) => {
    token = input;
    if (!token) { 
        tokenForm.classList.remove('hidden');

        return; 
    }

    localStorage.setItem('token', token);
    loadTodos(token)
        .then((items) => {
            app.classList.remove('hidden');
            tokenForm.classList.add('hidden');
            items.forEach((todo) => {
                createTodoElement(todo.title, todo.deadline, todo.completed, todo.id);
            });
        })
        .catch(() => {
            tokenForm.querySelector('input').classList.add('border-red-500');
            tokenForm.classList.remove('hidden');
        });
}
setToken(localStorage.getItem('token'));

const createTodoElement = (title, deadline, completed, id) => {
    if ('' === title) {
        return;
    }

    const clone = todoTemplate.content.cloneNode(true);
    clone.querySelector('li').dataset.id = id;
    if (completed) {
        clone.querySelector('li').classList.add('line-through')
    }
    clone.querySelector('[role="title"]').innerText = title + ' (' + deadline + ')';
    clone.querySelector('li').onclick = (e) => {
        const liElement = e.currentTarget.closest('li');
        const data = { completed: true };
        if (liElement.classList.contains('line-through')) {
            data.completed = false;
        }

        putTodo(token, id, data).then(() => {
            liElement.classList.toggle('line-through')
        });
    }

    clone.querySelector('[role="delete"]').onclick = (e) => {
        e.stopPropagation();

        const liElement = e.currentTarget.closest('li');
        deleteTodo(token, id).then(() => {
            liElement.remove();
            counter.innerText = todos.children.length;
        });
    }

    todos.append(clone.querySelector('li'));
    counter.innerText = todos.children.length;
}

tokenForm.querySelector('form').onsubmit = (e) => {
    e.preventDefault();

    setToken(e.currentTarget[0].value);

    e.currentTarget[0].blur();
    e.currentTarget[0].value = '';
};

form.onsubmit = (e) => {
    e.preventDefault();

    postTodo(token, e.currentTarget[0].value, e.currentTarget[1].value).then((todo) => {
        createTodoElement(todo.title, todo.deadline, todo.completed, todo.id);
    });

    e.currentTarget[0].value = '';
    e.currentTarget[1].value = new Date().toJSON().split('T')[0];
}

clearCompleted.onclick = () => {
    todos.querySelectorAll('li.line-through').forEach((element) => {
        deleteTodo(token, element.dataset.id).then(() => {
            element.remove();
            counter.innerText = todos.children.length;
        });
    });
}

filterAll.onclick = () => {
    removeClass(todos.querySelectorAll('li'), 'hidden');
}

filterActive.onclick = () => {
    removeClass(todos.querySelectorAll('li'), 'hidden');
    addClass(todos.querySelectorAll('li.line-through'), 'hidden');
}

filterCompleted.onclick = () => {
    removeClass(todos.querySelectorAll('li'), 'hidden');
    addClass(todos.querySelectorAll('li:not(.line-through)'), 'hidden');
}

const addClass = (elements, className) => {
    elements.forEach((el) => {
        el.classList.add(className);
    });
}

const removeClass = (elements, className) => {
    elements.forEach((el) => {
        el.classList.remove(className);
    });
}

// mobile-menu
document.querySelectorAll('[aria-controls]').forEach((element) => {
    element.onclick = () => {
        document.getElementById(element.attributes['aria-controls'].value).classList.toggle('hidden');
    }
});
